import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { StatusFilter } from './status_filter';
const footerIsPhoneCss = "f1u1gsnl";
const footerCss = "f1q0obtp";
const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(footerCss, {
    [footerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const resetButtonWrapperIsPhoneCss = "rmyrewa";
const resetButtonWrapperCss = "rase99w";
const ResetButtonWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(resetButtonWrapperCss, {
    [resetButtonWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const styledButtonIsPhoneCss = "sckc6ue";
const styledButtonCss = "s1dyln2p";
const StyledButton = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <Button ref={ref} {...props} className={classNames(styledButtonCss, {
    [styledButtonIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const DropdownContent = ({
  initialStatus,
  onSearch,
  onCancel
}) => {
  const [selectedStatus, setSelectedStatus] = useState(initialStatus);
  const onApply = () => onSearch({
    status: selectedStatus
  });
  const onReset = () => setSelectedStatus([]);
  const onStatusChange = (isChecked, status) => {
    if (isChecked) {
      setSelectedStatus([...selectedStatus, status]);
    } else {
      setSelectedStatus(selectedStatus.filter(selected => selected !== status));
    }
  };
  return <>
      <StatusFilter value={selectedStatus} onChange={onStatusChange} />
      <Footer>
        <ResetButtonWrapper>
          <MinimalButton onClick={onReset}>
            {I18n.t('publisher.meetings.filter_modal.reset')}
          </MinimalButton>
        </ResetButtonWrapper>
        <StyledButton size="small" decoration="secondary-outline" onClick={onCancel}>
          {I18n.t('publisher.action.cancel')}
        </StyledButton>
        <StyledButton size="small" onClick={onApply}>
          {I18n.t('publisher.action.apply')}
        </StyledButton>
      </Footer>
    </>;
};

require("./filter_dropdown.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./filter_dropdown.js");